import { ReactNode } from 'react';
import { connect, useSelector } from 'react-redux';
import { RootState } from '../../../../../@types/RootState';
import { ContextMenu, ContextMenuContent, ContextMenuSeparator, ContextMenuTrigger } from '../../../../../components';
import {
  ContextMenuRow,
  selectorContextMenu,
  selectorContextMenuItemOffer,
  selectorContextMenuRow,
} from '../../../../../reducers/gerenciadorPrecos/contextMenu';
import OptimizationContextMenu from './OptimizationContextMenu/OptimizationContextMenu';
import PriceCompositionContextMenu from './PriceComposition/PriceCompositionContextMenu';
import PriceEventHistoryContextMenu from './PriceEventHistory/PriceEventHistoryContextMenu';
import RuleCompositionContextMenu from './RuleComposition/RuleCompositionContextMenu';
import RuleCompositionOfferContextMenu from './RuleCompositionOffer/RuleCompositionOfferContextMenu';
import UndoOfferPriceChangesContextMenu, { isOfferPriceEdited } from './UndoOfferPriceChangesContextMenu';
import UndoPriceChangesContextMenu from './UndoPriceChangesContextMenu';

type PriceManagerContextMenuProps = {
  children: ReactNode;
} & ReturnType<typeof mapStateToProps>;

const RegularRowItems = () => (
  <>
    <UndoPriceChangesContextMenu />
    <OptimizationContextMenu />
    <PriceCompositionContextMenu />
    <RuleCompositionContextMenu />
    <PriceEventHistoryContextMenu />
  </>
);

// Na oferta, Desfazer e Regra 3 Oferta podem não aparecer: o separador só fica entre grupos com item.
const OfferRowItems = () => {
  const hasUndo = isOfferPriceEdited(useSelector(selectorContextMenu)?.offerDetails);
  const hasRule = !!useSelector(selectorContextMenuItemOffer)?.ruleId;

  return (
    <>
      <UndoOfferPriceChangesContextMenu />
      {hasUndo && hasRule && <ContextMenuSeparator />}
      <RuleCompositionOfferContextMenu />
      <PriceEventHistoryContextMenu withSeparator={hasUndo || hasRule} />
    </>
  );
};

// Itens do menu por linha clicada: a sub-linha Atacado usa os mesmos itens da linha principal.
const ITEMS_BY_ROW: Record<ContextMenuRow, () => JSX.Element> = {
  REGULAR: RegularRowItems,
  WHOLESALE: RegularRowItems,
  OFFER: OfferRowItems,
};

const PriceManagerContextMenu = ({ children, contextMenuDatapoint, contextMenuRow }: PriceManagerContextMenuProps) => {
  const RowItems = ITEMS_BY_ROW[contextMenuRow ?? 'REGULAR'];

  return (
    <ContextMenu>
      <ContextMenuTrigger>{children}</ContextMenuTrigger>
      <ContextMenuContent>{contextMenuDatapoint && <RowItems />}</ContextMenuContent>
    </ContextMenu>
  );
};

const mapStateToProps = (state: RootState) => ({
  contextMenuDatapoint: selectorContextMenu(state),
  contextMenuRow: selectorContextMenuRow(state),
});

export default connect(mapStateToProps)(PriceManagerContextMenu);
